import { forwardRef, useId } from 'react';
import styles from './parts.module.css';

/** Label + control + hint + error, wired with htmlFor/id and aria-describedby. */
const Field = forwardRef(({ label, hint, error, as: Tag = 'input', children, ...rest }, ref) => {
    const id = useId();
    const hintId = `${id}-hint`;
    const errorId = `${id}-error`;
    const describedBy = [hint && hintId, error && errorId].filter(Boolean).join(' ') || undefined;
    return (
        <div className={styles.field}>
            <label className={styles.label} htmlFor={id}>
                {label}
            </label>
            <Tag
                id={id}
                ref={ref}
                className={styles.control}
                aria-invalid={error ? 'true' : undefined}
                aria-describedby={describedBy}
                {...rest}
            >
                {children}
            </Tag>
            {hint && (
                <span id={hintId} className={styles.hint}>
                    {hint}
                </span>
            )}
            {error && (
                <span id={errorId} className={styles.error} role="alert">
                    {error}
                </span>
            )}
        </div>
    );
});

export default Field;
